import { tv } from 'tailwind-variants';

export const drawerVariants = tv({
    slots: {
        overlay: 'fixed inset-0 z-modal bg-black/40',
        content: 'fixed z-modal flex flex-col rounded-lg bg-white shadow-lg outline-none',
        header: 'flex shrink-0 items-start justify-between gap-3 border-b border-gray-200 px-5 py-4',
        title: 'text-lg font-semibold text-gray-900',
        description: 'mt-1 text-sm text-gray-600',
        body: 'flex-1 overflow-y-auto px-5 py-4',
        footer: 'flex shrink-0 justify-end gap-3 border-t border-gray-200 px-5 py-3',
        close: 'absolute right-4 top-4 rounded-md bg-white text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
    },
    variants: {
        direction: {
            right: { content: 'inset-y-3 right-3 w-[calc(100vw-1.5rem)]' },
            left: { content: 'inset-y-3 left-3 w-[calc(100vw-1.5rem)]' },
            top: { content: 'inset-x-3 top-3' },
            bottom: { content: 'inset-x-3 bottom-3' },
        },
        size: {
            sm: {},
            md: {},
            lg: {},
            xl: {},
            full: {},
        },
    },
    compoundVariants: [
        { direction: 'right', size: 'sm', class: { content: 'max-w-sm' } },
        { direction: 'right', size: 'md', class: { content: 'max-w-md' } },
        { direction: 'right', size: 'lg', class: { content: 'max-w-lg' } },
        { direction: 'right', size: 'xl', class: { content: 'max-w-xl' } },
        { direction: 'left', size: 'sm', class: { content: 'max-w-sm' } },
        { direction: 'left', size: 'md', class: { content: 'max-w-md' } },
        { direction: 'left', size: 'lg', class: { content: 'max-w-lg' } },
        { direction: 'left', size: 'xl', class: { content: 'max-w-xl' } },
        { direction: 'top', size: 'sm', class: { content: 'h-1/4' } },
        { direction: 'top', size: 'md', class: { content: 'h-1/3' } },
        { direction: 'top', size: 'lg', class: { content: 'h-1/2' } },
        { direction: 'top', size: 'xl', class: { content: 'h-3/4' } },
        { direction: 'bottom', size: 'sm', class: { content: 'h-1/4' } },
        { direction: 'bottom', size: 'md', class: { content: 'h-1/3' } },
        { direction: 'bottom', size: 'lg', class: { content: 'h-1/2' } },
        { direction: 'bottom', size: 'xl', class: { content: 'h-3/4' } },
        { size: 'full', class: { content: 'inset-0 w-screen h-screen max-w-none' } },
    ],
    defaultVariants: { direction: 'right', size: 'md' },
});
